var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCornerResizeHandle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8DDAF2",
  d: "M24 0v20a4 4 0 0 1-4 4H0L24 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M20.999 14.684v3.182L17.866 21h-3.182l6.315-6.316zm0-6.717v3.182L11.15 21H7.965L21 7.967z"
}))));
export default SvgIconCornerResizeHandle;